import React from "react";
import { useIntl } from "react-intl";
import { useFormikContext } from "formik";
import { object, string, number } from "yup";
import { useHistory } from "react-router-dom";
import { Form, Button, Row, Space } from "@masterteam/mt-design-react";

import Upload from "../../Upload";
import AdminFormModal from "../../AdminFormModal";

import api from "../../../providers/api";
import { addToast, sortByOrder } from "../../../helpers";

import "./style.scss";

const { Field } = Form;

const validationSchema = object().shape({
  EnglishName: string().required(" "),
  ArabicName: string().required(" "),
  Order: number().required(" ").min(1, " "),
  Attachment: object().required(" ").nullable(),
});

const ValuesForm = ({ data = null, closeModal, getPrograms }) => {
  const intl = useIntl();
  const { values: mainValues, setFieldValue } = useFormikContext();

  const initialValues = data || {
    EnglishName: "",
    ArabicName: "",
    Order: "",
    Attachment: null,
  };

  const onSubmit = async (values, { setSubmitting }) => {
    try {
      const newData = [...mainValues.Values];
      const body = {
        ...values,
        index: data?.index || newData?.length + 1,
      };

      if (data) {
        const index = newData.findIndex((e) => e.index === data.index);

        newData[index] = body;
      } else {
        newData.push(body);
      }

      setFieldValue("Values", sortByOrder([...newData]));
    } catch (error) {
      addToast.error(error?.message, {
        toastId: "get-users-error",
      });
    } finally {
      setSubmitting(false);
      closeModal();
    }
  };

  return (
    <AdminFormModal
      title={intl.formatMessage({
        id: data ? "strategy.update-value" : "strategy.add-value",
      })}
      isLoading={false}
      onClose={closeModal}
    >
      <Form
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, errors, isSubmitting, isValid, setFieldValue }) => (
          <>
            <Space
              direction="vertical"
              size="medium"
              className="values-form-body"
            >
              <Space
                direction="vertical"
                size="medium"
                className="form-container"
              >
                <Row size="small">
                  <Field
                    name="ArabicName"
                    label={intl.formatMessage({ id: "strategy.arabic-value" })}
                    inputProps={{
                      placeholder: intl.formatMessage({
                        id: "strategy.arabic-value",
                      }),
                    }}
                    hideErrorMessage
                    required
                  />
                  <Field
                    name="EnglishName"
                    label={intl.formatMessage({
                      id: "strategy.english-value",
                    })}
                    inputProps={{
                      placeholder: intl.formatMessage({
                        id: "strategy.english-value",
                      }),
                    }}
                    hideErrorMessage
                    required
                  />
                </Row>

                <Row size="small">
                  <Space className="icon-wrapper">
                    <Space gap="3px">
                      {intl.formatMessage({ id: "common.icon" })}
                      <span className="asterisk">*</span>
                    </Space>
                    <Upload
                      name="Attachment"
                      error={errors.Attachment}
                      onChange={(file) => setFieldValue("Attachment", file)}
                      onDelete={() => setFieldValue("Attachment", null)}
                      attachments={values.Attachment}
                      accept={{
                        "image/svg+xml": [".svg"],
                      }}
                    />
                  </Space>

                  <Field
                    type="number"
                    name="Order"
                    label={intl.formatMessage({
                      id: "common.order",
                    })}
                    inputProps={{
                      onKeyDown: (evt) => {
                        if (
                          evt.key === "e" ||
                          evt.key === "-" ||
                          evt.key === "+"
                        ) {
                          evt.preventDefault();
                        }
                      },
                      placeholder: intl.formatMessage({
                        id: "common.order",
                      }),
                    }}
                    required
                  />
                </Row>
              </Space>

              <Row justify="end" className="form-footer">
                <Button
                  loading={isSubmitting}
                  disabled={!isValid}
                  variant="primary"
                  type="submit"
                  fixed
                >
                  {intl.formatMessage({
                    id: data ? "common.update" : "common.add",
                  })}
                </Button>
              </Row>
            </Space>
          </>
        )}
      </Form>
    </AdminFormModal>
  );
};

export default ValuesForm;
